export default __webpack_public_path__ + "static/media/arrow-left.4eeee5f7.svg";